import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e2f6f940"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "item-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_item_file = _resolveComponent("item-file")!
  const _component_item_photo = _resolveComponent("item-photo")!
  const _component_item_folder = _resolveComponent("item-folder")!
  const _component_item_case = _resolveComponent("item-case")!
  const _component_app_skeleton_media = _resolveComponent("app-skeleton-media")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mixedList, (mixed) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "item",
        key: mixed.id
      }, [
        (mixed.type === _ctx.MIXED_DATA_TYPE.FILE)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "disabled",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.block && _ctx.block(...args)))
            }, [
              (mixed.file!.type === _ctx.MEDIA_TYPES.FILES)
                ? (_openBlock(), _createBlock(_component_item_file, {
                    key: 0,
                    file: mixed.file!,
                    hideDelete: "",
                    columnView: ""
                  }, null, 8, ["file"]))
                : _createCommentVNode("", true),
              (mixed.file!.type === _ctx.MEDIA_TYPES.PHOTO || mixed.file!.type === _ctx.MEDIA_TYPES.VIDEO)
                ? (_openBlock(), _createBlock(_component_item_photo, {
                    key: 1,
                    photo: mixed.file!,
                    hideDelete: "",
                    columnView: ""
                  }, null, 8, ["photo"]))
                : _createCommentVNode("", true)
            ]))
          : (mixed.type === _ctx.MIXED_DATA_TYPE.FOLDER)
            ? (_openBlock(), _createBlock(_component_item_folder, {
                key: 1,
                folder: mixed.folder!,
                class: _normalizeClass({ disabled: _ctx.movingItem?.id === mixed.id }),
                disableOptions: true,
                onOpenFolder: ($event: any) => (_ctx.openFolder(mixed.id)),
                hideDelete: "",
                columnView: "",
                disableMove: "",
                disableShare: ""
              }, null, 8, ["folder", "class", "onOpenFolder"]))
            : (mixed.type === _ctx.MIXED_DATA_TYPE.CASE)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: "disabled",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.block && _ctx.block(...args)))
                }, [
                  _createVNode(_component_item_case, {
                    iCase: mixed.case!,
                    columnView: ""
                  }, null, 8, ["iCase"])
                ]))
              : _createCommentVNode("", true)
      ]))
    }), 128)),
    (_ctx.loadingMore)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(21, (n) => {
          return _createElementVNode("div", {
            key: n,
            class: "item"
          }, [
            _createVNode(_component_app_skeleton_media, { columnView: "" })
          ])
        }), 64))
      : _createCommentVNode("", true)
  ]))
}